import React from "react";
import SEO from "../components/SEO";

const Guaranteed = () => {
  return (
    <>
              <SEO
        title='Guaranteed'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="min-h-screen bg-gradient-to-br from-[#437d6a]/10 via-white to-[#437d6a]/5">
        <div className="container mx-auto px-4 py-20 max-w-6xl">

          {/* Hero */}
          <div className="text-center mb-20">
            <span className="inline-block mb-4 px-5 py-2 rounded-full bg-[#437d6a]/15 text-[#437d6a] font-semibold text-md">
              Our Promise to You
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
              Satisfaction Guarantee
            </h1>
            <p className="mt-5 text-lg text-gray-600 max-w-3xl mx-auto">
              At <strong>Personalised Patches for Hats</strong>, your satisfaction
              matters. Every order is carefully crafted and backed by our quality
              promise.
            </p>
          </div>

          {/* Guarantee Cards Section */}
          <div className="relative mb-20">

            {/* Background Accent */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-[#437d6a]/10 via-[#437d6a]/5 to-[#32c394bd]/10"></div>

            <div className="relative grid md:grid-cols-3 gap-8 p-8">

              {/* Card 1 */}
              <div className="group bg-white/90 backdrop-blur rounded-3xl p-8 text-center 
                    border border-[#437d6a]/15 shadow-lg
                    hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center 
                      rounded-full bg-[#437d6a]/15 text-[#437d6a] text-3xl
                      group-hover:bg-[#437d6a] group-hover:text-white transition">
                  🛠
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Production Errors Covered
                </h3>
                <p className="text-gray-600">
                  If your patches arrive with any production defects, submit an order issue
                  form within <strong className="text-[#437d6a]">45 days</strong> of delivery.
                </p>
              </div>

              {/* Card 2 */}
              <div className="group bg-white/90 backdrop-blur rounded-3xl p-8 text-center 
                    border border-[#437d6a]/15 shadow-lg
                    hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center 
                      rounded-full bg-[#437d6a]/15 text-[#437d6a] text-3xl
                      group-hover:bg-[#437d6a] group-hover:text-white transition">
                  📸
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Simple Verification
                </h3>
                <p className="text-gray-600">
                  We may request photos or additional details to ensure your order is
                  reproduced exactly as intended.
                </p>
              </div>

              {/* Card 3 */}
              <div className="group bg-white/90 backdrop-blur rounded-3xl p-8 text-center 
                    border border-[#437d6a]/15 shadow-lg
                    hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center 
                      rounded-full bg-[#437d6a]/15 text-[#437d6a] text-3xl
                      group-hover:bg-[#437d6a] group-hover:text-white transition">
                  🚫📦
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  No Returns Required
                </h3>
                <p className="text-gray-600">
                  You’ll <strong className="text-[#437d6a]">never be asked to return</strong>
                  products before we approve a replacement or reproduction.
                </p>
              </div>

            </div>
          </div>



          {/* Policy Section */}
          <div className="bg-white rounded-3xl shadow-lg p-10 md:p-14 max-w-4xl mx-auto border border-[#437d6a]/10">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Our Guarantee Policy
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                If you experience any issues related to production quality,
                misprints, or defects, please notify us within <strong>45 days</strong>
                of confirmed delivery.
              </p>
              <p>
                Orders reported after this timeframe may not be eligible for
                replacement or refund.
              </p>
              <p>
                Our mission is to resolve issues quickly, fairly, and with minimal
                effort on your part.
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="mt-20 bg-gradient-to-r from-[#437d6a] to-[#356657] text-white rounded-3xl p-10 text-center shadow-xl">
            <h3 className="text-2xl font-bold mb-3">
              Need Help or Have Questions?
            </h3>
            <p className="mb-6 text-white/90">
              Our friendly support team is always ready to assist you.
            </p>
            <div className="space-y-1 font-semibold">
              <p>📞 (703) 666-8193</p>
              <p>📧 support@personalisedpatchesforhats.com</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Guaranteed;
